"use client";

import { Row } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import * as React from "react";

export interface IProps {
  label?: string;
  value?: string;
  className?: string;
}

export const ReadOnlyText: React.FC<IProps> = ({ label, value, className }) => {
  return (
    <Row gap="1x" className={className}>
      {label ? <Typography>{label}:</Typography> : null}
      <Typography>{value}</Typography>
    </Row>
  );
};
